import SvgClock from "@uui/Clock";
import SvgPercent03 from "@uui/Percent03";

import {
  Stack,
  Tooltip,
  ToggleButton,
  ToggleButtonGroup,
  styled,
} from "@mui/material";

import { TimeKeeperMetricType, ToggleFn } from "./types";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    height: "36px",
    width: "36px",
    border: 0,
    backgroundColor: theme.palette.shades.ghost[400],
    color: theme.palette.shades.primary[300],
    "&.Mui-disabled": {
      border: 0,
    },
    "&.Mui-selected": {
      color: "white",
      backgroundColor: theme.palette.overlay.primary[24],
      borderRadius: theme.shape.borderRadius,
      zIndex: 1,
    },
  },
}));

const MetricToggle = ({
  metric,
  onToggle,
}: {
  metric: TimeKeeperMetricType;
  onToggle: ToggleFn;
}) => {
  return (
    <Stack>
      <StyledToggleButtonGroup exclusive value={metric} onChange={onToggle}>
        <ToggleButton value="percent">
          <Tooltip title="Show percentage" arrow enterDelay={500}>
            <Stack alignItems="center" justifyContent="center">
              <SvgPercent03 sx={{ width: "20px", height: "20px" }} />
            </Stack>
          </Tooltip>
        </ToggleButton>
        <ToggleButton value="time">
          <Tooltip title="Show time" arrow enterDelay={500}>
            <Stack alignItems="center" justifyContent="center">
              <SvgClock sx={{ width: "20px", height: "20px" }} />
            </Stack>
          </Tooltip>
        </ToggleButton>
      </StyledToggleButtonGroup>
    </Stack>
  );
};

export default MetricToggle;
